import { cloneDeep } from 'lodash';

const confirmRejectPoint = (state, payload) => {
  const { placeId, pointId } = payload;

  if (!placeId || !pointId) return state;
  const newState = cloneDeep(state);

  delete newState.calls[pointId];

  for (const orderId in newState.activeEvents) {
    const order = newState.activeEvents[orderId];
    if (order.pointId === pointId) {
      delete newState.activeEvents[orderId];
    }
  }

  return newState;
};

export { confirmRejectPoint };
